var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgParticipantPlaceholder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 126,
    height: 126,
    viewBox: "0 0 126 126",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-445 -442) translate(448 445)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#B3B5B7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: "M79.4 78.672C70.384 76.834 61.201 75.939 52 76c-22.28 0-36.988 4.662-44.906 8.174C2.767 86.099-.016 90.398 0 95.134V116h64M24 28C24 12.536 36.536 0 52 0s28 12.536 28 28-12.536 32-28 32-28-16.536-28-32z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 96,
    r: 24,
    stroke: "#B3B5B7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B3B5B7",
    fillRule: "nonzero",
    d: "M102 102c0 1.657-1.343 3-3 3H87c-1.657 0-3-1.343-3-3V90c0-1.657 1.343-3 3-3h12c1.657 0 3 1.343 3 3v3l4.8-3.6c.331-.249.801-.181 1.05.15.097.13.15.288.15.45v12c0 .414-.336.75-.75.75-.162 0-.32-.053-.45-.15L102 99v3zM88.5 90c-.828 0-1.5.672-1.5 1.5s.672 1.5 1.5 1.5 1.5-.672 1.5-1.5-.672-1.5-1.5-1.5z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParticipantPlaceholder);
export default __webpack_public_path__ + "static/media/participant-placeholder.60a6b4b2fb3f4676c9d989c50639473b.svg";
export { ForwardRef as ReactComponent };